<div class="" ngbDropdown>
  <!-- begin::Menu -->
  <button type="button"
          [ngClass]="selected.length>0 ? 'btn-light-primary':'btn-active-light-primary'"
          class="btn btn-sm btn-icon btn-color-primary  ms-2"
          data-kt-menu-trigger="click"
          data-kt-menu-placement="bottom-end"
          data-kt-menu-flip="top-end" ngbDropdownToggle>
                <span [inlineSVG]="'./assets/images/bars-filter.svg'"
                      class="svg-icon svg-icon-4"></span>
  </button>
  <div ngbDropdownMenu aria-labelledby="timeLine-trie" class="card-body p-sm-7">
    <div *ngIf="Multiple" class="d-flex">
    <ng-container *ngIf="selected">
                            <span *ngFor="let item of selected " class="badge badge-light-primary bg-body-secondary mb-2 me-2 mt-3 p-3 w-auto">{{ item?.label }}
                              <a class="cursor-pointer" (click)="removeItem(item)">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="currentColor"></rect>
                                        <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="currentColor"></rect>
                                    </svg>
                                </a>
                            </span>
    </ng-container>
    </div>
    <div class="w-200px">
   <lcms-select-filter [isLoading]="Loading" (SearchItem)="search($event)"  [title]="'Inscription.roles' | translate" [items]="Items" (selectedItemsChange)="getList($event)" [clear]="Multiple ?? true" ></lcms-select-filter>
    </div>
    <!-- start dynamic dashboard -->
<!--    <ng-container *ngFor="let filter of dashbordFilterList;let is_last=last">-->
<!--      <ng-container *ngIf="filter?.action">-->
<!--        <div ngbDropdownItem class="px-7">-->
<!--          <a (click)="filterTimeTutor(filter?.action)" class="text-center d-flex  text-muted h6 cursor-pointer"> {{filter.label | translate}} </a>-->
<!--        </div>-->
<!--      </ng-container>-->
<!--      <ng-container *ngIf="filter?.children">-->
<!--        <div-->
<!--          ngbDropdown-->
<!--          #myDropdown="ngbDropdown"-->
<!--          data-kt-menu-trigger="{default: 'click' , lg:'hover'}"-->
<!--          data-kt-menu-placement="left-start"-->
<!--          data-kt-menu-flip="bottom"-->
<!--          class="menu-item px-5 dropdown-submenu"-->
<!--          id="dropdownDate"-->
<!--        >-->
<!--          <div ngbDropdownToggle class="menu-link px-2  cursor-pointer" data-kt-menu-flip="left" aria-labelledby="dropdownDate">-->
<!--            <a class="text-center text-muted h6 menu-title- position-relative flex-row">-->
<!--              {{filter.label| translate}}-->
<!--              <i class="fa-solid fa-chevron-circle-right fs-6"></i>-->
<!--            </a>-->
<!--            <div ngbDropdownMenu class=" menu-sub menu-sub-date w-175px py-4"  >-->
<!--              <div *ngFor="let child of filter.children" (click)="filterTimeTutor(child.action)" ngbDropdownItem class=" text-center menu-item px-3 cursor-pointer">-->
<!--                <span  class="text-center text-muted   menu-link d-flex px-5 active h6">{{child.label| translate}}</span>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </ng-container>-->
<!--      <div *ngIf="!is_last" class="separator my-0"></div>-->
<!--    </ng-container>-->

    <!-- end dynamique dashboard -->
    </div>
  </div>
  <!-- end::Menu -->

